export const SystemFeedbacks = {
	['offline-error']:
		'Estamos com problema de conexão! Por favor, verifique sua internet, tentaremos novamente em ',
	['connection-returned']: 'Voltamos!',

	['session-expired']: 'Sua sessão expirou',
	['session-were-trying-reconnect']:
		'Estamos tentando reconectar, pode ser que você precise logar novamente',

	['session-restored']: 'Sua sessão foi restaurada',
	['session-success-restored']: 'Conseguimos restaurar sua sessão.',

	['feedback-error-segmentation']: 'Ops! Tivemos um problema com essa página',
	['feedback-error-segmentation-button']: 'Tente uma nova tarefa',
};
